module.exports = __webpack_public_path__ + "7a0b73ba70ec41166caa5584eb596aae.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/image4.png
 ** module id = 282
 ** module chunks = 0
 **/